import { apiService } from './index';

export const asyncGetCaseManagement = async (
    userId: string,
    page?: number,
    pageSize?: number
) => {
    return await apiService.get('/api/case-manager/by-user', {
        userId: userId,
        limit: pageSize || 20,
        page: page || 0,
    });
};

export const asyncPatchIdCaseManagement = async (caseId: string, data: any) => {
    return await apiService.put(`/api/case-manager/${caseId}`, data);
};
